// Expenses whose accountings require the same documentation (e.g. "Deltagarlista") share the same
// participant list / attachment, even when the accountings are different.
// Accountings without required documentation are grouped by their own accountingId.

export function GetDocumentGroupKey(item) {
    const docs = Array.isArray(item?.requiredDocumentation)
        ? item.requiredDocumentation.filter(doc => typeof doc === "string" && doc.trim() !== "")
        : [];
    if (docs.length === 0) {
        return `accounting:${item?.accountingId ?? ""}`;
    }
    return `docs:${docs.map(doc => doc.trim().toLowerCase()).sort().join("|")}`;
}

// True when the item belongs to the same group as the entry identified by id (accountingId or temporalId)
export function IsInSameDocumentGroup(list, item, id) {
    if (item?.accountingId === id || item?.temporalId === id) {
        return true;
    }
    const target = Array.isArray(list) ? list.find(other => other.accountingId === id || other.temporalId === id) : null;
    return !!target && GetDocumentGroupKey(target) === GetDocumentGroupKey(item);
}

export function HasFilledAdditionalInfo(item) {
    return Object.values(item?.additionalInfo || {}).some(value => value !== null && value !== undefined && value !== "");
}

export function GetSharedGroupValues(source) {
    return {
        additionalInfo: { ...(source?.additionalInfo || {}) },
        additionalFileName: source?.additionalFileName || "",
        additionalFileExtension: source?.additionalFileExtension || "",
        selectedRadioOption: source?.selectedRadioOption || null,
    };
}

// Copies the values of the first filled entry of each group to the rest of the entries of that group
export function ShareInfoByDocumentGroup(list) {
    if (!Array.isArray(list)) {
        return list;
    }
    const sources = {};
    list.forEach(item => {
        const key = GetDocumentGroupKey(item);
        if (!sources[key] && HasFilledAdditionalInfo(item)) {
            sources[key] = item;
        }
    });
    return list.map(item => {
        const source = sources[GetDocumentGroupKey(item)];
        if (!source || source === item) {
            return item;
        }
        const shared = GetSharedGroupValues(source);
        return {
            ...item,
            ...shared,
            additionalInfo: { ...(item.additionalInfo || {}), ...shared.additionalInfo },
        };
    });
}

// Keeps only the first entry of each group (the one shown and validated in the participants panel)
export function UniqueByDocumentGroup(list) {
    if (!Array.isArray(list)) {
        return [];
    }
    return list.filter((item, index, self) =>
        index === self.findIndex(other => GetDocumentGroupKey(other) === GetDocumentGroupKey(item))
    );
}
